export default ElementEdicomClass;

ElementEdicomClass.$inject = [];

const WITHOUT_ATTRIBUTE_VALUE = 'WITHOUT_ATTRIBUTE_VALUE';

function ElementEdicomClass() {
  return ElementEdicom;
}

function ElementEdicom(elementName) {
  this.element = elementName || '';
  this.attrs = {};
  this.childs = [];
  this.childsJQuery = [];
  this.html = '';
  this.id = '';
  this.type = '';
  this.cssClass = [];
  this.cssStyle = [];
}

ElementEdicom.prototype.getHtml = getHtml;
ElementEdicom.prototype.toString = getHtml;
ElementEdicom.prototype.setHtml = setHtml; // set html
ElementEdicom.prototype.setId = setId;
ElementEdicom.prototype.setType = setType;
ElementEdicom.prototype.addClass = addClass;
ElementEdicom.prototype.addStyle = addStyle;
ElementEdicom.prototype.addAttribute = addAttribute;
ElementEdicom.prototype.addAttributeIf = addAttributeIf;
ElementEdicom.prototype.addAttributes = addAttributes;
ElementEdicom.prototype.removeAttribute = removeAttribute;
ElementEdicom.prototype.append = append;
ElementEdicom.prototype.appendChild = append;
ElementEdicom.prototype.prepend = prepend;
ElementEdicom.prototype.getChilds = getChilds;

function getHtml() {
  var html = `<${this.element}`;
  writeId.call(this);
  writeType.call(this);
  writeClass.call(this);
  writeStyle.call(this);
  writeAttributes.call(this);
  html += '>';
  writeChilds.call(this);
  writeChildsJQuery.call(this);
  writeHtml.call(this);
  html += `</${this.element}>`;
  return html;

  // ///////////////////////

  function writeId() {
    if (this.id) {
      html += ` id="${this.id}" `;
    }
  }

  function writeType() {
    if (this.type) {
      html += ` type="${this.type}" `;
    }
  }

  function writeClass() {
    if (!this.cssClass.length) {
      return;
    }
    html += ' class="';
    for (var i = 0, len = this.cssClass.length; i < len; i++) {
      html += `${this.cssClass[i]} `;
    }
    html += '" ';
  }

  function writeStyle() {
    if (!this.cssStyle.length) {
      return;
    }
    html += ' style="';
    for (var i = 0, len = this.cssStyle.length; i < len; i++) {
      html += `${this.cssStyle[i]};`;
    }
    html += '" ';
  }

  function writeAttributes() {
    for (var key in this.attrs) {
      html += this.attrs[key] !== WITHOUT_ATTRIBUTE_VALUE ? ` data-${key}=${this.attrs[key]}` : ` ${key}`;
      // html += (this.attrs[key] !== WITHOUT_ATTRIBUTE_VALUE) ? ' ' + key + '=' + this.attrs[key] : ' ' + key;
    }
  }
  function writeChilds() {
    for (var i = 0, len = this.childs.length; i < len; i++) {
      html += this.childs[i].getHtml();
    }
  }
  function writeChildsJQuery() {
    for (var i = 0, len = this.childsJQuery.length; i < len; i++) {
      html += this.childsJQuery[i][0].outerHTML;
    }
  }
  function writeHtml() {
    html += this.html;
  }
}

function addClass(str) {
  var t = str.split(' ');
  for (var i = 0, len = t.length; i < len; i++) {
    this.cssClass.push(t[i]);
  }
  return this;
}

function addStyle(str) {
  var t = str.split(';');
  for (var i = 0, len = t.length; i < len; i++) {
    this.cssStyle.push(t[i]);
  }
  return this;
}

function addAttribute(attributeName, attributeValue, onlyIfValueNotBlank, quote) {
  if (!onlyIfValueNotBlank || (attributeValue !== '' && typeof attributeValue !== 'undefined')) {
    quote = quote || '"';
    this.attrs[attributeName] = attributeValue !== '' ? quote + attributeValue + quote : WITHOUT_ATTRIBUTE_VALUE;
  }
  return this;
}

function addAttributeIf(condition, attributeName, attributeValue, onlyIfValueNotBlank, quote) {
  if (condition) {
    return addAttribute.call(this, attributeName, attributeValue, onlyIfValueNotBlank, quote);
  }
  return this;
}

function addAttributes(attrs, onlyIfValueNotBlank, quote) {
  for (var key in attrs) {
    addAttribute.call(this, key, attrs[key], onlyIfValueNotBlank, quote);
  }
  return this;
}

function removeAttribute(attributeName) {
  if (this.attrs[attributeName]) {
    delete this.attrs[attributeName];
  }
  return this;
}

function setId(str) {
  if (typeof str === 'string') {
    this.id = str;
  }
  return this;
}

function setType(str) {
  if (typeof str === 'string') {
    this.type = str;
  }
  return this;
}

function setHtml(str) {
  if (typeof str === 'string') {
    this.html = str;
  }
  return this;
}

function getChilds() {
  return this.childs;
}

function append(child) {
  if (Array.isArray(child)) {
    const that = this;
    child.forEach(item => that.append(item));
    return this;
  }
  if (child instanceof ElementEdicom) {
    this.childs.push(child);
  }
  if (typeof $ !== 'undefined' && child instanceof $) {
    this.childsJQuery.push(child);
  }
  return this;
}

function prepend(child) {
  if (child instanceof ElementEdicom) {
    this.childs.unshift(child);
  }
  if (typeof $ !== 'undefined' && child instanceof $) {
    this.childsJQuery.unshift(child);
  }
  return this;
}
